module.exports = __webpack_public_path__ + "static/media/xmark.453428ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmark.svg
// module id = 97
// module chunks = 0